// @core/api/endpoints/signature/list_parties.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPartiesResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * List signing parties
 * Returns paginated list of parties filterable by target (any polymorphic Entity), party_actor, role, and status. Use ListPartiesByTarget for the common 'parties of this document/order/...' case.
 */
export async function ListParties(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListPartiesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/parties`;
  const requestOptions = options;
  return client.get<ListPartiesResponse>(requestPath, { ...requestOptions, params });
}
